import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { NS } from '@/screens/Service/ducks/reducer';
import {
  getDraftOpenApiSpecs,
  deleteDraftOpenApiSpec,
  updateCrumbs
} from '@/screens/Service/ducks/actions';

import { DraftPages } from '../../components/DraftPages';

export const DraftApiDocs = props => {
  const { updateCrumbs } = props;
  useEffect(() => {
    updateCrumbs([
      {
        label: 'Drafts Open API Specs'
      }
    ]);
  }, []);
  return <DraftPages nameField="version" {...props} />;
};

const mapStateToProps = state => ({
  service: state.getIn([NS, 'service']),
  drafts: state.getIn([NS, 'draftOpenApiSpecs']),
  pending: state.getIn([NS, 'pending', 'draftOpenApiSpecs'])
});
const mapDispatchToProps = dispatch => ({
  getDrafts: handle => dispatch(getDraftOpenApiSpecs(handle)),
  deleteDraft: id => dispatch(deleteDraftOpenApiSpec(id)),
  updateCrumbs: crumbs => dispatch(updateCrumbs(crumbs))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DraftApiDocs);
